import React from "react";
import { useSelector } from "react-redux";
import SchuelerListItem from "./SchuelerListItem";
import SchuelerEntwurfListItem from "./SchuelerEntwurfListItem";

const SchuelerList = ({ props }) => {
  const schueler = useSelector((st) => st.schueler);
  const gutachten = schueler.filter((s) => !s.entwurf);
  const entwuerfe = schueler.filter((s) => !!s.entwurf);

  return (
    <div className="mt-3">
      <div style={{border:"1px solid grey", borderRadius:"5px"}} className="p-3">
        <h5>Entwürfe</h5>
        <div style={{ columnCount: 4 }} className="mb-2">
          {entwuerfe.map((s) => (
            <SchuelerEntwurfListItem key={s.id} props={props} schueler={s} />
          ))}
        </div>
      </div>
      <div style={{border:"1px solid grey", borderRadius:"5px"}} className="p-3 my-1">
        <h5>Gutachten</h5>
        <div style={{ columnCount: 4 }} className="mb-2">
          {gutachten.map((s) => (
            <SchuelerListItem key={s.id} props={props} schueler={s} />
          ))}
        </div>
      </div>
    </div>
  );
};
export default SchuelerList;
